import { GatewayBlockBody, GatewayBlockRequest } from './types'

export const toBlockRequestBody = ({
  clientId,
  gatewayId,
  isBlocked,
  reason,
}: GatewayBlockRequest): GatewayBlockBody => {
  const body: GatewayBlockBody = {
    client: Number(clientId),
    gateway: gatewayId,
    isBlocked,
  }

  // Unblocking takes no reason — sending the text left in the modal would
  // overwrite the reason stored for the previous block.
  if (isBlocked && reason?.trim()) body.reason = reason.trim()

  return body
}
